import Vue from 'vue';
import axios from 'axios';
import VueCookies  from 'vue-cookies';

const BASE_URL = process.env.VUE_APP_BACKEND ? process.env.VUE_APP_BACKEND : 'http://mercedino-demo.zedplan.com/api/'//Vue.$apiAdress; Perdon por el hardcode

let apiTokenGetter = () => {


    let cookieValue = window.$cookies.get(process.env.VUE_APP_API_TOKEN_NAME)

    //let storedToken = Vue.$cookies.get(process.env.VUE_APP_API_TOKEN_NAME);
    if (cookieValue) {
        return `Bearer ${cookieValue}`;
    } else {
        return ''
    }
}
/**
 * 
 * La onda acá sería poder crear un urlString de manera facilonga y que se pueda repetir
 * 
 * BASE_URL + 'path/to/resource' es lo que se me ocurrió hasta ahora.
 * 
 */
const $axios = axios.create({
    headers: {
        'Authorization': apiTokenGetter()
    }
});


const api = {
    menu: {
        index: (params) => $axios.get(BASE_URL + 'menu', {params})
    },
    users: {
        index: (params) => $axios.get(BASE_URL + 'users', {params}),
        store: (body) => $axios({
            method: 'post',
            url: BASE_URL + 'users',
            data: body
        }),
        update: (userId, body) => $axios({
            method: 'post',
            url: BASE_URL + `users/${userId}`,
            data: body
        }),
        roles: () => $axios.get(BASE_URL + 'users/resources/roles'),
        departments: () => $axios.get(BASE_URL + 'users/resources/departments'),
        getUserById: (userId) => $axios.get(BASE_URL + `users/${userId}`),
        deactivate: (userId) => $axios.delete(BASE_URL + `users/${userId}`),
        activate: (userId) => $axios.put(BASE_URL + `users/activate/${userId}`),
        resetPassword: (body) => $axios({
            method: 'post',
            url: BASE_URL + `users/reset_password`,
            data: body
        })
    },
    orders: {
        index: (params) => $axios.get(BASE_URL + 'orders', {params}),
        store: (body) => $axios({
            method: 'post',
            url: BASE_URL + 'orders',
            data: body
        }),
        show: (orderId) => $axios.get(BASE_URL + `orders/${orderId}`),
        update: (orderId, body) => $axios({
            method: 'put',
            url: BASE_URL + `orders/${orderId}`,
            data: body
        }),
        download: (orderId) => $axios.get(BASE_URL + `orders/${orderId}/download`),
        setBuyedOrder: (body) => $axios({
            method: 'post',
            url: BASE_URL + `orders/setBuyedOrder`,
            data: body
        }),
        setReceivedOrder: (body) => $axios({
            method: 'post',
            url: BASE_URL + `orders/setReceivedOrder`,
            data: body
        }),
        setDeliveredOrder: (body) => $axios({
            method: 'post',
            url: BASE_URL + `orders/setDeliveredOrder`,
            data: body
        }),
    },
    delivered_order_descriptions:{ 
        index: (description_id) => $axios.get(BASE_URL + `delivered_order_descriptions/${description_id}`)
    },
    buyed_order_descriptions: {
        index: (description_id) => $axios.get(BASE_URL + `buyed_order_descriptions/${description_id}`)
    },
    scheduled_orders: {
        index: (params) => $axios.get(BASE_URL + "scheduled_orders", {params}),
        store: (body) => $axios({
            method: 'post',
            url: BASE_URL + 'scheduled_orders',
            data: body
        }),
        update: (scheduledOrderId, body) => $axios({
            method: 'put',
            url: BASE_URL + `scheduled_orders/${scheduledOrderId}`,
            data: body
        }),
        show: (orderId) => $axios.get(BASE_URL + `scheduled_orders/${orderId}`),
        deactivate: (scheduledOrderId) => $axios.delete(BASE_URL + `scheduled_orders/${scheduledOrderId}`),
        activate: (scheduledOrderId) => $axios.put(BASE_URL + `scheduled_orders/activate/${scheduledOrderId}`)

    },
    auth: {
        user: (data) => $axios.get(BASE_URL + 'auth/user', {data}),
        login: (data) => $axios.post(BASE_URL + 'auth/login', {data}),
        logout: (data) => $axios.post(BASE_URL + 'auth/logout', {data})
    },
    departments: {
        index: (data) => $axios.get(BASE_URL + 'departments')
    },
    priorities: {
        index: (data) => $axios.get(BASE_URL + 'priorities')
    },
    statuses: {
        index: (data) => $axios.get(BASE_URL + 'statuses')
    },
    item_form: {
        store: (body) => $axios({
            method: 'post',
            url: BASE_URL + 'item_form',
            data: body
        })
    }

}

Vue.prototype.$api = api;

export default api;